import { ActionIcon, Badge } from '@mantine/core';
import { memo } from 'react';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import {
	ExpandableCounterTagsCellContainer,
	ExpandableCounterTagsCellContentContainer,
	ExpandableCounterTagsCellName,
	ExpandableCounterTagsCellBadgesContainer,
} from './styled';
import { Row } from '@tanstack/react-table';
import { BaseValuationRow } from '@dealstack/frontend/app/pages/Valuations/components/table/types';
import { TextV2 } from '@dealstack/frontend/shared/components/TextV2/TextV2';
import { useTheme } from 'styled-components';
import { useTranslationValuations } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';
import { TEST_ELEMENT_IDS, makeComplexDataTestId } from '@dealstack/shared/tests/testElementIds';

interface Props {
	value: string | null;
	count: number;
	phraseLabel: string;
	row: Row<BaseValuationRow>;
	isExpanded: boolean;
	onExpansionToggle?: () => void;
	italic?: boolean;
}

/**
 * @deprecated This component is deprecated and will be removed. Please utilise the columnBuilder instead.
 */
export const ExpandableCounterTagsCell = memo<Props>(
	({ value, count, phraseLabel, row, isExpanded, onExpansionToggle, italic }) => {
		const theme = useTheme();
		const handleExpand = (e: React.MouseEvent) => {
			e.stopPropagation();
			row.toggleExpanded();
			onExpansionToggle?.();
		};
		const tValuations = useTranslationValuations();

		return (
			<ExpandableCounterTagsCellContainer
				data-testid={makeComplexDataTestId(
					TEST_ELEMENT_IDS.EXPANDABLE_COUNTER_TAG_CELL,
					value
				)}
				style={italic ? { fontStyle: 'italic' } : undefined}
			>
				<ExpandableCounterTagsCellContentContainer>
					<ExpandableCounterTagsCellName
						data-testid={TEST_ELEMENT_IDS.EXPANDABLE_COUNTER_TAG_CELL_NAME}
					>
						<TextV2 variant="sans/14/400">{value ?? ''}</TextV2>
					</ExpandableCounterTagsCellName>
					<ExpandableCounterTagsCellBadgesContainer>
						<Badge
							size="lg"
							style={{
								color: theme.v2.color.neutral[1000],
								backgroundColor: theme.v2.color.neutral[200],
								padding: '0 0.5rem',
							}}
						>
							<TextV2
								data-testid={TEST_ELEMENT_IDS.EXPANDABLE_COUNTER_TAG_CELL_BADGE}
								variant="sans/11/400"
								noWrap={true}
							>
								{tValuations(phraseLabel, { count })}
							</TextV2>
						</Badge>
					</ExpandableCounterTagsCellBadgesContainer>
				</ExpandableCounterTagsCellContentContainer>
				{row.original.subRows && (
					<ActionIcon
						data-testid={TEST_ELEMENT_IDS.EXPANDABLE_COUNTER_TAG_CELL_EXPAND_BTN}
						size="lg"
						variant="subtle"
						style={{ backgroundColor: 'transparent' }}
						onClick={handleExpand}
					>
						<Icon
							variant={isExpanded ? 'caret-down' : 'caret-right'}
							size="lg"
							color={defaultTheme.v3.colors.black[0]}
						/>
					</ActionIcon>
				)}
			</ExpandableCounterTagsCellContainer>
		);
	}
);
